<template
  ><!-- 弹框 -->
  <el-dialog
    :visible.sync="visible"
    class="pending-order-dialog"
    width="820px"
    center
    :append-to-body="true"
    :before-close="setOrderFlag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="pending-order-content">
      <div class="header">
        <i
          class="el-icon-close"
          style="font-size: 20px;cursor: pointer;"
          @click="setOrderFlag"
        ></i>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待处理订单" name="order">
            <div style="padding: 0 16px;">
              <el-table
                v-loading="loading"
                :data="tableData"
                style="width: 100%"
                :max-height="'450px'"
              >
                <el-table-column prop="createdAt" label="推送日期" width="160">
                </el-table-column>
                <el-table-column
                  prop="deliveryDay"
                  label="要求发货"
                  width="100"
                >
                </el-table-column>
                <el-table-column prop="mainNumber" label="主订单号" width="160">
                </el-table-column>
                <el-table-column prop="status" label="主单状态" width="140">
                </el-table-column>
                <el-table-column
                  prop="orderNumber"
                  label="子订单号"
                  width="160"
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="产品名称"
                  width="160"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column prop="num" label="产品数量" width="80">
                </el-table-column>
                <el-table-column prop="price" label="产品金额" width="100">
                </el-table-column>
              </el-table>
              <el-pagination
                style="margin-top: 20px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="size"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100]"
                :pager-count="11"
                layout="total, sizes, prev, pager, next"
                :total="totalElements"
                v-if="totalElements"
              >
              </el-pagination>
              <div class="order-tips" v-if="totalElements">
                以上部分待发货订单涉及运费补贴，请各位商家及时关注并按时履约！
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="待处理售后单" name="asOrder">
            <asOrder ref="asRef" @setOrderFlag="setOrderFlag"></asOrder>
          </el-tab-pane>
          <el-tab-pane label="待处理拒收单" name="refuseOrder" v-if="isPingtai">
            <refuseOrder ref="refuseRef"></refuseOrder>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { queryPendingOrder } from "@/models/dataReportmodel";
import { mapGetters } from "vuex";
import asOrder from "./asOrder.vue";
import refuseOrder from "./refuseOrder.vue";
export default {
  name: "pendingOrderDialog",
  data() {
    return {
      tableData: [],
      loading: false,
      page: 1,
      size: 100,
      totalElements: 0,
      activeName: "order",
      visible: false,
      isPingtai: localStorage.getItem("shop_type") == "0"
    };
  },
  computed: {
    ...mapGetters(["pendingOrderFlag"])
  },
  components: {
    asOrder,
    refuseOrder
  },
  watch: {
    pendingOrderFlag: {
      handler: function(newVal) {
        // console.log("new--val:", newVal, localStorage.getItem("shop_type"));
        this.isPingtai = localStorage.getItem("shop_type") == "0";
        this.visible = newVal ? true : false;
        if (newVal === "order") {
          this.activeName = "order";
          this.getPenderOder();
        } else if (newVal === "as-order") {
          this.activeName = "asOrder";
          this.$nextTick(() => {
            this.$refs.asRef.getList(1, 10);
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    //获取未处理工单列表
    async getPenderOder() {
      const shop_id = Number(localStorage.getItem("shop_id"));
      this.loading = true;
      try {
        const params = {
          shop_id,
          page: this.page || 1,
          page_size: this.size || 100
        };
        const res = await queryPendingOrder(params);
        this.tableData = res.list || [];
        this.totalElements = res.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message.error(error.message);
      }
    },
    setOrderFlag() {
      this.$store.dispatch("app/isQueryPendingOrder", false);
      this.page = 1;
      this.size = 10;
      this.totalElements = 0;
      this.$refs.asRef.clearTimer();
    },

    // 每页条数
    handleSizeChange(val) {
      this.loading = true;
      this.size = val;
      this.page = 1;
      this.getPenderOder();
    },
    // 页码改变
    handleCurrentChange(val) {
      this.loading = true;
      this.page = val;
      this.getPenderOder();
    },
    handleClick(e) {
      // console.log(e.$options.propsData);
      const activeKey = e.$options.propsData.name;
      if (activeKey === "refuseOrder") {
        this.$refs.refuseRef.getList(1, 10);
      } else if (activeKey === "asOrder") {
        this.$refs.asRef.getList(1, 10);
      }
    }
  }
};
</script>
<style lang="scss">
.pending-order-dialog {
  .el-dialog.el-dialog--center {
    border-radius: 10px;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    color: inherit;
  }

  .header div {
    font-weight: normal;
  }
  .header .el-icon-close {
    position: absolute;
    top: 24px;
    right: 20px;
    z-index: 99;
  }

  .el-dialog--center .el-dialog__body {
    // padding: 16px 16px 12px;
    padding: 16px 0 12px;
  }
  .el-dialog .el-pagination__jump .el-input {
    width: 50px !important;
  }
  .el-tabs__header {
    padding: 0 16px;
  }
  .order-tips {
    position: absolute;
    bottom: 30px;
    color: red;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingOrder/index.vue